export function formatUSPhoneNumber(phoneNumber: string) {
  // Remove all non-digit characters from the phone number
  const digits = phoneNumber.replace(/\D/g, "");

  // Check if the phone number is valid (i.e., has exactly 10 digits)
  if (digits.length !== 10) {
    return phoneNumber;
  }

  // Format the phone number
  const formatted = digits.replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3");

  return formatted;
}

export function formatDynamicUSPhoneNumber(
  phoneNumber: string,
  hideAreaCode = false,
) {
  return phoneNumber.split("").reduce((result, n, index) => {
    const dashIndex = hideAreaCode ? 3 : 6;
    if (index === 0 && !hideAreaCode) result += "(";
    if (index === 3 && !hideAreaCode) result += ") ";
    if (index === dashIndex) result += "-";
    result += n;
    return result;
  }, "");
}

export const letterToDigit: { [key: string]: string } = {
  A: "2",
  B: "2",
  C: "2",
  D: "3",
  E: "3",
  F: "3",
  G: "4",
  H: "4",
  I: "4",
  J: "5",
  K: "5",
  L: "5",
  M: "6",
  N: "6",
  O: "6",
  P: "7",
  Q: "7",
  R: "7",
  S: "7",
  T: "8",
  U: "8",
  V: "8",
  W: "9",
  X: "9",
  Y: "9",
  Z: "9",
};

export function textToNumbers(text: string) {
  return text
    .toUpperCase()
    .split("")
    .map((letter) => letterToDigit[letter] || letter)
    .join("");
}

export function setPhraseToPhoneNumber(
  phoneNumberDigits: string,
  phrase: string,
) {
  const phraseDigits = textToNumbers(phrase);
  const searchStart = 3;
  const phraseIndex = phoneNumberDigits
    .slice(searchStart)
    .indexOf(phraseDigits);
  const adjustedPhraseIndex =
    phraseIndex === -1 ? -1 : phraseIndex + searchStart;

  console.log(
    "setPhraseToPhoneNumber: ",
    phoneNumberDigits,
    phraseDigits,
    phrase,
    phraseIndex,
  );
  if (adjustedPhraseIndex === -1) {
    return phoneNumberDigits;
  }

  let prefix = phoneNumberDigits.slice(0, adjustedPhraseIndex);
  let suffix = phoneNumberDigits.slice(adjustedPhraseIndex + phrase.length);

  if (prefix.length > 3) {
    prefix += "-";
  }

  if (suffix.length > 0) {
    suffix = "-" + suffix;
  }

  if (prefix.length >= 3) {
    prefix = `(${prefix.slice(0, 3)}) ${prefix.slice(3)}`;
  }

  return `${prefix}${phrase}${suffix}`;
}

export function hasLetters(phoneNumber: string) {
  return /[A-Z]/.test(phoneNumber);
}

export function formatPhoneNumber(phoneNumber: string, searchTerm: string) {
  if (hasLetters(searchTerm)) {
    return setPhraseToPhoneNumber(phoneNumber, searchTerm);
  }

  return formatUSPhoneNumber(phoneNumber);
}
